import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTranscribedCalls = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 41,
	height: 41,
	viewBox: "0 0 41 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: .333374,
			y: .5,
			width: 40,
			height: 40,
			rx: 20,
			fill: "#F0F3F9"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_4771_101792)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M29.4668 17.6938L29.7134 17.1281C30.1529 16.1195 30.9445 15.3164 31.9323 14.8771L32.6919 14.5392C33.1027 14.3565 33.1027 13.7588 32.6919 13.5761L31.9748 13.2571C30.9616 12.8065 30.1558 11.9737 29.7238 10.9308L29.4706 10.3195C29.2942 9.89349 28.7058 9.89349 28.5293 10.3195L28.2761 10.9308C27.8442 11.9737 27.0384 12.8065 26.0252 13.2571L25.308 13.5761C24.8973 13.7588 24.8973 14.3565 25.308 14.5392L26.0677 14.8771C27.0555 15.3164 27.8471 16.1195 28.2866 17.1281L28.5331 17.6938C28.7136 18.1079 29.2864 18.1079 29.4668 17.6938ZM11 13C11 12.4477 11.4477 12 12 12H23V14H13V28H29V20H31V29C31 29.5523 30.5523 30 30 30H12C11.4477 30 11 29.5523 11 29V13ZM16 17H26V20H24V19H22V23H23.5V25H18.5V23H20V19H18V20H16V17Z",
				fill: "#003399"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_4771_101792",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(8.66638 8.5)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgTranscribedCalls);
export { ForwardRef as ReactComponent };
